import React, { useEffect, useState } from "react";
import styles from "./CalculatorForm.module.scss";
import MainButton from "../../../../shared/button/MainButton";
import SelectComponent from "../../../../shared/select/SelectComponent";
import countryIcon from "../../../../../assets/images/calculator/CountryIcon.svg";
import tarifIcon from "../../../../../assets/images/calculator/TarifIcon.svg";
import {
  CountriesDataType,
  PaymentDataType,
} from "../../../../../interface/site.interface";
import { CountriesService } from "../../../../../services/countries.service";
import { CalculatorService } from "../../../../../services/calculator.service";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

export default function CalculatorForm() {
  const [messageModal, setMesssageModal] = useState<boolean>(false);
  const [countries, setCountries] = useState<CountriesDataType[]>([]);
  const [calculaterDEliveryType, setCalculatorDEliveryDataType] = useState<
    PaymentDataType[]
  >([]);
  const [formData, setFormData] = useState({
    country: null as number | null,
    type: null as number | null,
    unit: "kg",
    weight: null as number | null,
    width: null as number | null,
    height: null as number | null,
    length: null as number | null,
  });
const language = useSelector((state: RootState) => state.language.language);

  const [responseMessage, setResponseMessage] = useState<string>("");
  const [errors, setErrors] = useState({
    country: "",
    type: "",
    weight: "",
    width: "",
    height: "",
    length: "",
  });
  const [endPice, setEndPrice] = useState([]);
  useEffect(() => {
    CountriesService.getAllCountries()
      .then((res) => {
        const data = res?.data?.original;
        setCountries(data);
      })
      .catch((err) => {
      });

    CalculatorService.getCalculatorDeliveryType()
      .then((res) => {
        const data = res?.data?.original;
        setCalculatorDEliveryDataType(data);
      })
      .catch((err) => {
      });
  }, [language]);

  const handleCountryChange = async (val: string | number) => {
    const countryId = Number(val);
    setFormData({
      ...formData,
      country: countryId,
      type: null,
    });

    try {
      const response = await CalculatorService.getCalculatorCountry(countryId);
      if (response.status === 200) {
        setCalculatorDEliveryDataType(response.data?.original || []);
      } else {
        setCalculatorDEliveryDataType([]);
      }
    } catch (err) {
      console.error("Error in handleCountryChange:", err);
      setCalculatorDEliveryDataType([]);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    setErrors({
      country: "",
      type: "",
      weight: "",
      width: "",
      height: "",
      length: "",
    });

    CalculatorService.calculateData(formData).then((res) => {
      const data = res?.data;

      if (res.status === 200 && data?.original?.case === "success") {
        setMesssageModal(true);
        setEndPrice(data?.original?.amount);
        setResponseMessage("Uğurla hesablandı!");
      } else if (res?.status !== 200) {
        const content = res.response?.data?.content;
        const newErrors: any = {};
        if (content) {
          for (const key in content) {
            if (content[key]?.length > 0) {
              newErrors[key] = content[key].join(", ");
            }
          }
        }
        setErrors(newErrors);
        setResponseMessage(data?.error_occurred);
      } else {
        setResponseMessage(data?.error_occurred);
      }
    });
  };

  return (
    <div className={styles.calculator}>
      <form className={styles.form}>
        <div className={styles.selects}>
          <SelectComponent
            name="country"
            options={countries.map((country) => ({
              label: country.title,
              value: country.id,
            }))}
            value={formData.country ?? undefined}
            onChange={(val: any) => handleCountryChange(val.value ?? val)}
            placeholder="Ölkə"
            icon={countryIcon}
            className={"home_calc_select"}
            error={errors.country}
          />

          <SelectComponent
            name="tarif"
            options={calculaterDEliveryType.map((type) => ({
              label: type.title,
              value: type.id,
            }))}
            value={formData.type ?? undefined}
            onChange={(val: any) =>
              setFormData({
                ...formData,
                type: Number(val.value ?? val),
              })
            }
            placeholder="Daşınma növü"
            icon={tarifIcon}
            className={"home_calc_select"}
            error={errors.type}
            disabled={!formData.country}
          />
        </div>

        <div className={styles.inputs}>
          <div className={styles.input}>
            <div className={styles.errorInput}>
              <input
                type="number"
                name="weight"
                id="weight"
                placeholder="Çəki (kq)"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    weight: Number(e.target.value),
                  })
                }
              />
              {errors.weight && (
                <p className={styles.errorWeight}>{errors.weight}</p>
              )}
            </div>
            <input
              type="number"
              name="height"
              id="height"
              placeholder="Hündürlük(sm)"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  height: Number(e.target.value),
                })
              }
            />
            {errors.height && (
              <p className={styles.errorHeight}>{errors.height}</p>
            )}
          </div>

          <div className={styles.input}>
            <input
              type="number"
              name="width"
              id="width"
              placeholder="En(sm)"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  width: Number(e.target.value),
                })
              }
            />
            {errors.width && (
              <p className={styles.errorWidth}>{errors.width}</p>
            )}

            <input
              type="number"
              name="length"
              id="length"
              placeholder="Uzunluq(sm)"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  length: Number(e.target.value),
                })
              }
            />
            {errors.length && (
              <p className={styles.errorLength}>{errors.length}</p>
            )}
          </div>
        </div>
      </form>

      <div className={styles.Endamount}>
        {endPice && endPice.length !== 0 && (
          <p>Hesablanan qiymət: {endPice} AZN</p>
        )}
      </div>

      <MainButton
        text="Hesabla"
        className={styles.calculate_btn}
        onClick={handleSubmit}
        disabled={!formData.country || !formData.type}
      />

      {responseMessage && (
        <GlobalModalComponent
          isOpen={messageModal}
          onClose={() => setMesssageModal(false)}
        >
          <div className={styles.response_message}>
            <p>{responseMessage}</p>
            {endPice && endPice.length !== 0 && (
              <p className={styles.success_price}>Qiymət: {endPice} AZN</p>
            )}
          </div>
        </GlobalModalComponent>
      )}
    </div>
  );
}
